/** Action key that carries PROMISE calls info interpreted by this Redux Middleware. */
export const PROMISE_REQUEST = 'PROMISE_REQUEST';
